<template>
  <Tooltip side="bottom" :side-offset="8" :delay-duration="400">
    <router-link
      :to="{
        name: 'prototype',
        params: { hash: projectHash },
        query: {
          entrypoint: ANALYTICS_ENABLED ? 'play_btn' : undefined,
        },
      }"
      class="text-accent-400 hover:bg-neutral-50/[0.12] py-2 px-3 inline-flex"
      target="_blank"
    >
      <Play class="size-6" />
    </router-link>
    <template #content>
      <p>Play Mode</p>
    </template>
  </Tooltip>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { Play } from 'lucide-vue-next';
import { Tooltip } from '@ui/components/tooltip';

const ANALYTICS_ENABLED = process.env.MIX_ANALYTICS_ENABLED;

const store = useStore();

const projectHash = computed(() => store.getters['user/projects/getOpen']);
</script>
